import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsSV from './sv.lng.json';
import translationsNB from './nb.lng.json';
import translationsFI from './fi.lng.json';

export { useTranslation, Trans } from 'react-i18next';

export const i18nInit = language => {
  const i18nConfig = {
    resources: {
      svSE: { translation: translationsSV },
      nbNO: { translation: translationsNB },
      svFI: { translation: translationsSV },
      fiFI: { translation: translationsFI }
    },
    lng: language,
    fallbackLng: 'svSE',
    returnObjects: true,
    debug: process.env.NODE_ENV !== 'production'
  };

  i18n.use(initReactI18next).init(i18nConfig);
};

export default i18n;
